import mod from "react-dom/client";
export default mod;
export const { createRoot, hydrateRoot, version } = mod;